import { Reference } from '@apollo/client'
import {
  BulkCreateContractsTaxonomiesDocument,
  BulkCreateContractsTaxonomiesMutationVariables,
  ContractTaxonomyFragmentDoc,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useBulkCreateContractsTaxonomies = () => {
  const [BulkCreateContractsTaxonomy, { loading }] = useMutation(
    BulkCreateContractsTaxonomiesDocument,
    {
      extractorFn: (data) => data.contractsMutations.bulkCreateContractsTaxonomy,
      update: (cache, { data }) => {
        const taxonomies = data?.contractsMutations.bulkCreateContractsTaxonomy.taxonomies
        if (!taxonomies || taxonomies.length === 0) return

        const newTaxonomy = taxonomies[0]
        if (!newTaxonomy) return

        cache.modify({
          fields: {
            contracts(existingContractRefs = [], { readField }) {
              const existingTaxonomies = existingContractRefs['taxonomies']
              const newTaxonomyRef = cache.writeFragment({
                data: newTaxonomy,
                fragment: ContractTaxonomyFragmentDoc,
              })
              if (
                existingTaxonomies.some((ref: Reference) => readField('id', ref) === newTaxonomy.id)
              ) {
                return existingContractRefs
              }

              return {
                ...existingContractRefs,
                taxonomies: [...(existingTaxonomies ?? []), newTaxonomyRef],
              }
            },
          },
        })
      },
    }
  )

  return {
    loading,
    BulkCreateContractsTaxonomy(variables: BulkCreateContractsTaxonomiesMutationVariables) {
      return BulkCreateContractsTaxonomy({
        variables,
      })
    },
  }
}
